// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3zmLz","amount":"Amount_amount__KkcMO","tip":"Amount_tip__MQoIR","tipHeader":"Amount_tipHeader__3-P5c","tipsWrap":"Amount_tipsWrap__2IFmE"};